/* eslint-disable camelcase */

import loadable from '@loadable/component';

import keywordSearchPageQuery from './query.graphql';

const KeywordLandingPage = loadable(() =>
  import(/* webpackChunkName: "search" */ './components/index')
);

export const queryToVariables = vars => {
  const {
    offset = 0,
    slug = '',
    query = '',
    category_id = '',
    brand_id = '',
  } = vars;
  return {
    id: 'search',
    query,
    slug,
    offset: parseInt(offset, 10),
    limit: 100,
    categoryFilters: category_id.split(',').filter(Boolean),
    brandFilters: brand_id.split(',').filter(Boolean),
  };
};

KeywordLandingPage.variables = queryToVariables;

KeywordLandingPage.graphQL = keywordSearchPageQuery;

KeywordLandingPage.loadOrder = [{}];

KeywordLandingPage.group = ({ name, variables }) => {
  const groupVariables = variables
    ? Object.keys(variables)
        .filter(key => ['query', 'offset'].indexOf(key) > -1)
        .map(key => variables[key])
    : [];

  const filterVariables =
    variables && variables.filters
      ? variables.filters.map(filter => {
          switch (filter.id) {
            case 'category_id':
            case 'brand_id':
              return `${filter.id}:${filter.selected}`;
            case 'lowest_price':
            case 'user_rating':
              return `${filter.id}:${filter.from}:${filter.to}`;
            default:
              return filter.id;
          }
        })
      : [];

  return `${name}_${groupVariables.join('_')}_${filterVariables.join('_')}`;
};

export default KeywordLandingPage;
